import React from 'react';
import ReactDOM from 'react-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'antd/dist/antd.min.css';
import "swiper/swiper-bundle.css";
import './index.css';
import App from './App';
import { Provider } from "react-redux"
import { store } from "./redux/store";
import Wrapper from "./layouts/Shared/components/Wrapper";
import Notification from "./helpers/Notification";

// Desktop only: forward uncaught renderer errors / promise rejections to the main
// process log. React 16+ rethrows render-time crashes (the ones that otherwise show
// a silent blank screen in production) to window 'error', so this captures them too.
// Feature-detected via window.electron, so it is a no-op in the web build.
if (typeof window !== 'undefined' && window.electron && typeof window.electron.logError === 'function') {
  const forward = (kind, payload) => {
    try { window.electron.logError({ kind, ...payload }); } catch (_) { /* noop */ }
  };
  window.addEventListener('error', (e) => forward('window.error', {
    message: e.message,
    source: `${e.filename || ''}:${e.lineno || ''}:${e.colno || ''}`,
    stack: e.error && e.error.stack,
  }));
  window.addEventListener('unhandledrejection', (e) => {
    const r = e.reason;
    forward('unhandledRejection', { message: (r && r.message) || String(r), stack: r && r.stack });
  });
}

ReactDOM.render(
  <Provider store={store}>
    <ToastContainer
      position="top-center"
      autoClose={10000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      draggable={false}
    />
    <Wrapper>
      <App />     
    </Wrapper>   
    <Notification />
  </Provider>,
  document.getElementById('root')
);